import { render, staticRenderFns } from "./SalesRecord.vue?vue&type=template&id=35a459fc&"
import script from "./SalesRecord.vue?vue&type=script&lang=js&"
export * from "./SalesRecord.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports